import{Spinner as OriginSpinner,styled}from'tamagui';export const Spinner=styled(OriginSpinner,{color:'$icon'});